import { apiPutAlertsMarkSeenUuid, AuditRoomRow } from "../../api";
import { DataModel } from "../../models/data-model";

export class AuditRoomModel extends DataModel<AuditRoomRow> {
  readonly idAttr = "patient_id";

  async markAuditAlertsSeen(auditAlerts: Array<{ uuid: string }>) {
    await Promise.all(
      auditAlerts.map((alert) =>
        apiPutAlertsMarkSeenUuid({ path: { uuid: alert.uuid } }),
      ),
    );
  }
}
